import { StyleSheet } from 'react-native';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    metadataRow: {
        width: widthPercentageToDP(430, 580),
    },
    tabletEmbeddedMetadataRow: {
        width: widthPercentageToDP(308),
        marginLeft: 44,
    },
    marker: {
        justifyContent: 'center',
        alignItems: 'center',
        height: 20,
        borderRadius: 2,
        marginRight: 8,
    },
    markerIcons: {
        marginLeft: 0,
        marginRight: 10,
    },
    lastMarkerIcon: {
        marginRight: 0,
        marginLeft: 10,
    },
});

export default styles;
